import { useEffect, useState } from 'react';
import { Grid, Container, ToggleButton } from '@mui/material';
import { gridSpacing } from '../../constant/Constants';
import SingleCard from './manage-contract/SingleCard';
import VisibilityIcon from '@mui/icons-material/Visibility';
import ContractDetail from './manage-contract/ContractDetail';
import ShortTransactionHistory from '../main/ShortTransactionHistory';
import { makeStyles } from '@mui/styles';
import { useDispatch, useSelector } from 'react-redux';
import { showAlert } from '../../redux/create-actions/AlertAction';
import { resetCVV2, resetEcom } from '../../redux/create-actions/OtpAction';
import { formatDate } from '../../utils/function/Function';
import { closeLoadingApi, openLoadingApi } from '../../redux/create-actions/LoadingAction';
import Color from '../../layouts/Color';
import FontSize from '../../layouts/FontSize';
import { contractDetails, graphGetAllContractByCustomer } from '../../services/Contract';
import { transactionHistory } from '../../services/Transaction';

const useStyles = makeStyles(function (theme) {
    return {
        cardContainer: {
            [theme.breakpoints.down("sm")]: {
                width: '250px',
                padding: '0px !important',
                margin: '0 auto'
            },
        },
        button: {
            backgroundColor: Color.Dangerous,
            color: Color.Button,
            borderRadius: "8px",
            fontSize: FontSize.Tiny,
            paddingLeft: "10px",
            paddingRight: "10px",
            '&:hover': {
                backgroundColor: Color.Button,
                color: Color.Dangerous
            },
            '&.Mui-selected': {
                backgroundColor: Color.Button,
                color: Color.Dangerous
            },
            '&.Mui-selected:hover': {
                backgroundColor: Color.Button,
                color: Color.Dangerous
            },
        }
    };
});

const iconVisible = { ml: 0.5 };
const btnGrid = { mt: 2 }
const container = { mt: 2 };

export default function ManageContract() {
    var followingDay = new Date(new Date().getTime() - 86400000 * 7);
    const classes = useStyles();
    const [contracts, setContracts] = useState([]);
    const [contractId, setContractId] = useState(null);
    const [currentContract, setCurrentContract] = useState(null);
    const [contractDetail, setContractDetail] = useState(null);
    const [fromDate] = useState(formatDate(followingDay));
    const [toDate] = useState(formatDate(new Date()));
    const [contractShortHistory, setContractShortHistory] = useState([]);
    const [selected] = useState([]);
    const [isShow, setIsShow] = useState(false);
    const dataConfirm = useSelector(state => state.confirm.data);

    useEffect(() => {
        if (contractId !== null) {
            let contractDetail = contractDetails((contractId));
            contractDetail
                .then(result => {
                    setContractDetail(result);
                })
                .catch(function (error) {
                    const err = JSON.parse(JSON.stringify(error));
                    console.log(err);
                }).finally(() => {
                    dispatch(closeLoadingApi());
                })

        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [dataConfirm.active])


    const dispatch = useDispatch();

    useEffect(() => {
        if (contracts !== null) {
            for (var i = 0; i < contracts.length; i++) {
                selected[i] = false
            }
        }
    }, [contracts, selected])

    useEffect(() => {
        const promise = graphGetAllContractByCustomer();
        promise.then((result) => {
            setContracts(result.items);
        }).catch(error => {
            const err = JSON.parse(JSON.stringify(error));
            console.log(err);
            dispatch(closeLoadingApi());
        })
    }, [dispatch])

    const handleClick = (contract) => {
        setContractId(parseInt(contract.id))
        dispatch(openLoadingApi());
        dispatch(resetCVV2());
        dispatch(resetEcom());
        if (currentContract === contract) { setIsShow(!isShow) } else { setIsShow(true) }
        setCurrentContract(contract);
        let alert = {
            anchorOrigin: {
                vertical: 'top',
                horizontal: 'center'
            },
            isOpen: true,
            severity: 'error',
            title: 'Error',
            message: ''
        };
        if (contracts !== null) {
            let contractDetail = contractDetails(parseInt(contract.id));
            contractDetail
                .then(result => {
                    setContractDetail(result);
                })
                .catch(function (error) {
                    alert = { ...alert, message: "An error occurred while call api" };
                    dispatch(showAlert(alert));
                }).finally(() => {
                    dispatch(closeLoadingApi());
                })
            const data = {
                contractId: parseInt(contract.id),
                fromDate: fromDate,
                toDate: toDate
            }
            let transactionsHistory = transactionHistory(data);
            transactionsHistory
                .then(result => {
                    setContractShortHistory(result.data.TransactionList);
                }).catch(function (error) {
                    const err = JSON.parse(JSON.stringify(error));
                    console.log(err);
                })
        }

        for (var i = 0; i < selected.length; i++) {
            if (i === contracts.indexOf(contract)) {
                selected[i] = !selected[i]
            }
            else {
                selected[i] = false
            }
        }
    };


    return (contracts !== null) && (
        <Container component="main" maxWidth={false} sx={container} >
            <Grid container spacing={gridSpacing} textAlign="center">
                {contracts.map((contract) => (
                    <Grid key={contract.id} id={contract.id} item sm={12} xs={12} md={6} lg={3} textAlign="center">
                        <Grid textAlign="center" className={classes.cardContainer} >
                            <Grid item>
                                <SingleCard contract={contract} ></SingleCard>
                            </Grid>
                            <Grid item sx={btnGrid}>
                                <ToggleButton
                                    value="check"
                                    selected={selected[contracts.indexOf(contract)]}
                                    color="error"
                                    size="small"
                                    className={classes.button}
                                    onClick={() => handleClick(contract)}
                                >
                                    See Detail
                                    <VisibilityIcon fontSize={FontSize.Small} sx={iconVisible} />
                                </ToggleButton>
                            </Grid>
                        </Grid>
                    </Grid>
                ))}
                {(isShow) &&
                    <Grid container item spacing={2} mt={2}>
                        <Grid item xs={12} md={6}>
                            <ContractDetail contract={contractDetail}></ContractDetail>
                        </Grid>
                        <Grid item xs={12} md={6}>
                            <ShortTransactionHistory contractShortHistory={contractShortHistory} ></ShortTransactionHistory>
                        </Grid>
                    </Grid>
                }
            </Grid>
        </Container>
    );
}